var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":"","color":"transparent"}},[_c('v-card-text',{staticClass:"msr--text pa-0 wrap body-1 ml-3"},[_c('v-layout',{attrs:{"column":""}},[_c('strong',[_vm._v(_vm._s(_vm.$t('userManagementYourAdmin')))]),_vm._v("\n        "+_vm._s(_vm.$t('userManagementPleaseAskAdmin'))+" "+_vm._s(_vm.user.first_name)+"\n        "+_vm._s(_vm.user.last_name)+"\n      ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UserManagement/UserManagementAdminHint.vue?vue&type=template&id=2b2a92f6&
// module id = 2742
// module chunks = 5